import { pathgen } from 'object-path-generator';
import { LoadingText } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoadingIndicatorTestIds = pathgen('LoadingIndicatorTestIds');
export default function LoadingIndicator(_ref) {
  let {
    testId = LoadingIndicatorTestIds.Root()
  } = _ref;
  return /*#__PURE__*/_jsx(LoadingText, {
    testId: testId
  });
}